import React, { useEffect, useState } from 'react';
import { Button, Typography, Card,Modal,Row,Col,Drawer,Form,Input,DatePicker,Select  } from 'antd';
import { DollarOutlined,PlusOutlined } from '@ant-design/icons';
import Fileupload from "../../../common/fileupload/fileupload";
import { DocTypes, OwnerType, EntityTypes } from "../../../constants/commonConstants";
import './request-to-broker.scss';
import { checkIsSTO,checkIsBroker,checkIsCountryPresent, getCountryValidationVat, getCountryValidationTrade, minMaxLengthValidator } from "../../../util/constantUtility";
import { useStore } from "../../../store/store";
import { useTranslation } from "react-i18next";
import Notification from "../../../service/notification";
import Checkmark from '../../../assets/images/checkmark.svg';
import * as accountService from "../../../service/accountService";
import * as documentUtility from "../../../util/documentThumbUtility";
import dayjs from "dayjs";
import moment from 'moment';

const { Title, Paragraph } = Typography;

const RequestToBroker = (props) => {
const [vatForm] = Form.useForm();
  const [frontDocs, setFrontDocs] = useState({});

const { t } = useTranslation();
// const { saveUser } = useStore();
  const { user, saveUser } = useStore();

const [isBrokerModalOpen, setIsBrokerModalOpen] = useState(false);
const [saveUpgradeLoader, setSaveUpgradeLoader] = useState(false);
const [openAddDetailsDrawer, setopenAddDetailsDrawer] = useState(false);
const [buttonNameChange, setbuttonNameChange] = useState(false);
  const [kycFormValues, setKycFormValues] = useState({});
  const [ibanNumber, setIbanNumber] = useState([""]);
  const [changeUserTypeLoader, setchangeUserTypeLoader] = useState(false);
  const {min,max} = getCountryValidationVat(user?.operatingCountry)
    const {minTrade,maxTrade} = getCountryValidationTrade(user?.operatingCountry)
  const format = 'DD/MM/YYYY';


  useEffect(()=>{
getSupplierKycInfo()
  },[])


   const isTurkeyKazakhstanPresent = (user?.operatingCountry === "Turkey" ||
                                     user?.operatingCountry === "Kazakhstan" ||
                                     !checkIsCountryPresent(user?.operatingCountry));


  const onClickRequestUpgrade=()=>{
    setIsBrokerModalOpen(true);
  }

  const onClickSaveDetails=()=>{
    setSaveUpgradeLoader(true);
      accountService
                .saveRequestUpgrade()
                .then((response) => {
                  setSaveUpgradeLoader(false);
                  setIsBrokerModalOpen(false);
                  Notification.success(t("COMMON_SUCCESS_MSG"),t("BROKER_CONFIRMATION_SUCCESS_MSG"));
                  props.refreshBasicInfo();
                  setIsBrokerModalOpen(false);
                })
                .catch((error) => {
                  setSaveUpgradeLoader(false);
                });
  }
  const openAddDetailsModal = () =>{
    setopenAddDetailsDrawer(true)
  }
const onClose = () => {
    setopenAddDetailsDrawer(false);
  };

  const disablePastDates = (current) => {
      return current && current <= dayjs().endOf('day')
    };


      const onFileUploadDocs = (file, fieldName) => {    
    var updatedInquiryDocs = {...frontDocs};
    updatedInquiryDocs = {
      docType: file.DocType,
      fileName: file.FileName,
      fileThumbName: file.FileThumbName,
      fileUrl: file.FileURL,
      size: file.size,
      fileThumbUrl: file.FileThumbURL,
      fileData: file.fileData,
    };
        setFrontDocs(updatedInquiryDocs);
        // console.log(updatedInquiryDocs,'front')
         vatForm.setFieldsValue({
      [fieldName]: {
        docType: file.DocType,
        fileName: file.FileName,
        fileThumbName: file.FileThumbName,
        fileUrl: file.FileURL,
        isInsertUpdate: true,
        isPathSet: true,
        size: file.size,
        fileThumbUrl: file.FileThumbURL
      }
    })
  }


  //function to add new field for IBAN number
  const addIbanNumber = () => {
    let temp = [...ibanNumber];
    temp.push("");
    setIbanNumber(temp);
  }
      
//   const handleFormChange=(field,val)=>{
// vatForm.setFieldValue(field,val);
//   }

  const handleFormChange = (field, val) => {
    vatForm.setFieldValue(field, val);
    setKycFormValues((prev) => ({
      ...prev,
      [field]: val,
    }));
    vatForm.validateFields();
  };


const handleSumbitForm = async () => {
  setchangeUserTypeLoader(true)
          const values = vatForm.getFieldsValue();

 let payload = {
  vatCertificate: {
    documentNumber: values?.vatNumber,
    expiryDate: values?.vatExpiry ? moment(values?.vatExpiry, format).format("YYYY-MM-DD") : null,
    frontDoc: {
      isInsertUpdate: true,
      documentPath: values?.vatUpload?.fileUrl,
      documentPathThumb: values?.vatUpload?.fileThumbUrl,
      fileName: values?.vatUpload?.fileName,
      isPathSet: true,
    },
  },
  tradeLicense: {
    documentNumber: values?.tradeLicenseNumber,
    expiryDate: values?.tradeExpiry ? moment(values?.tradeExpiry, format).format("YYYY-MM-DD") : null,
    frontDoc: {
      isInsertUpdate: values?.tradeLicenseUpload?.isInsertUpdate,
      documentPath: values?.tradeLicenseUpload?.fileUrl,
      documentPathThumb: values?.tradeLicenseUpload?.fileThumbUrl,
      fileName: values?.tradeLicenseUpload?.fileName,
      isPathSet: true,
    },
  },
  ...(isTurkeyKazakhstanPresent && {
                certification: [values?.certification],
                iBanNo: ibanNumber,
  
  })   
  
};

  try {
    // console.log(vatForm.getFieldsValue())
    const form = await vatForm.validateFields(); 

    const response = await accountService.saveKYCInfo(payload);
    console.log(response.status, 'res');

    Notification.success(t("KYC_DETAIL_KEY"), t("KYC_DETAILS_SUCCESS"));
    if(response?.status == 200 ){
    setbuttonNameChange(true); 
    setchangeUserTypeLoader(false)
    setopenAddDetailsDrawer(false)
    props.refreshBasicInfo();
    if(props.userKycStatus === 'Approved'){
    props.submitHanlerFunction()
    }
    }
  } catch (error) {
    setchangeUserTypeLoader(false)
    console.error('Error submitting form:', error);
    // Notification.error(t("ERROR_KEY"), t("KYC_DETAILS_FAILED"));
  }
};

const getSupplierKycInfo = () => {
  accountService
    .getSupplierKycInfo(user?.userId)
    .then((response) => {
      let editFormValues;
      const result = response?.data?.data;
      console.log(result, "Supplier KYC Info");
       editFormValues = {
                  // vat reg details
                  vatNumber: result?.vatCertificate?.documentNumber,
                  vatExpiry: result?.vatCertificate?.expiryDate ? moment(result?.vatCertificate?.expiryDate).format(format) : null,
                  vatUpload: {
                    fileName: result?.vatCertificate?.frontDoc?.fileName,
                    fileUrl: result?.vatCertificate?.frontDoc?.documentPath,
                    fileThumbUrl: result?.vatCertificate?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                  },
      
                  //trade details
                  tradeLicenseNumber: result?.tradeLicense?.documentNumber,
                  tradeExpiry: result?.tradeLicense?.expiryDate ? moment(result?.tradeLicense?.expiryDate).format(format) : null,
                  tradeLicenseUpload: {
                    fileName: result?.tradeLicense?.frontDoc?.fileName,
                    fileUrl: result?.tradeLicense?.frontDoc?.documentPath,
                    fileThumbUrl: result?.tradeLicense?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                  },
                  iBanNo: [...(result?.iBanNo || [])],
                  registrationOffice: result?.registrationOffice,
                  certification: result?.certification?.length > 0 ? result?.certification[0] : ""
                };
        vatForm.setFieldsValue(editFormValues);
        setKycFormValues(editFormValues);
        setIbanNumber(result?.iBanNo)

      // setKycInfo(result);
    })
    .catch((error) => {
      console.error("Error fetching supplier KYC info:", error);
      Notification.error(t("ERROR_KEY"), t("KYC_FETCH_FAILED")); // optional error message
    });
};


useEffect(() => {
  if (kycFormValues?.iBanNo?.length) {
    const fields = {};
    kycFormValues.iBanNo.forEach((val, index) => {
      fields[`iBanNo_${index}`] = val;
    });
    vatForm.setFieldsValue(fields);
  }
}, [kycFormValues?.iBanNo]);


  return (
    <>
    <Card className="request-broker-card">
      <div className="request-broker-content">
        {(checkIsSTO(user?.userRole) && props.userKycStatus === 'Approved' && user?.status !== 'Blocked') &&
        <div className="text-content">
          <Title level={4}>
            {t("BROKER_TITLE_ONE")} <span className="highlight">{t("BROKER_TITLE_TWO")}</span> {t("BROKER_TITLE_THREE")}
          </Title>
          <Paragraph style={{marginBottom:'0px'}}>
            {t("BROKER_MAIN_MSG")}
          </Paragraph>
          {!props.isSTOConvertedInBroker ? <Button 
            type="primary" 
            size="large"
            icon={<DollarOutlined />}
            className="upgrade-button"
            disabled={saveUpgradeLoader}
            onClick={onClickRequestUpgrade}
          >
            {t("BROKER_REQUEST_BTN")}
          </Button>:
          <>
          <Row style={{marginTop:"18px"}}>
          <Col span={1}>
          <img src={Checkmark} alt="Checkmark" height={28} width={28}/>
          </Col>
          <Col>
          <span className='success-request-broker'>{t("BROKER_REQUEST_MSG")}</span>
          </Col>
          </Row>
          </>}

        </div>}

        {user?.status === 'Blocked' && 

         <div className={checkIsBroker(user?.userRole)?'blocked-div':'text-content'}>
          <Title level={4}>
          {/* You're Temporarily Blocked */}
          {t("PAYBLES_BLOCK_MSG")}
          </Title>
          <Paragraph style={{marginBottom:'0px'}}>
            {/* You are currently blocked due to crossing the business limit. Please upload required documents to regain access. */}
            {t("PAYBLES_BLOCK_STATEMENT")}
          </Paragraph>
    <Button
     type="primary" 
            size="large"
            icon={<DollarOutlined />}
            className="upgrade-button"
            onClick={openAddDetailsModal}>{props?.userKycStatus == 'Approval Pending' ?"Approval Pending" :t("PAYBLES_BLOCK_UPDATES_DETAILS_BTN")}</Button>

        </div>
        }


        {/* <div className="illustration">
        </div> */}
      </div> 



      


              <Modal
                className="logoutmodal"
                open={isBrokerModalOpen}
                centered="true"
                footer={false}
                onCancel={() => {
                  setIsBrokerModalOpen(false);
                }}
              >
                <div className="logout-content">
                  {/* <span className="logout-title">
                    {t("SETTINGS_LOGGING_OUT")}
                  </span> */}
                  <span className="logout-msg">
                    {t("BROKER_CONFIRMATION_MSG")}
                  </span>
                  <span className="logout-btn">
                    <Button type="secondary"
                      className="submit-btn"
                      loading={saveUpgradeLoader}
                      disabled={saveUpgradeLoader}
                      onClick={onClickSaveDetails}
                    >
                      {t("BROKER_UPGRADE_BTN")}
                    </Button>
                    <Button
                      className="cancel-btn"
                      disabled={saveUpgradeLoader}
                      onClick={() => {
                        setIsBrokerModalOpen(false)
                      }}
                    >
                      {t("COMMON_NO_BTN")}
                    </Button>
                  </span>
                </div>
              </Modal>

    </Card>


      <Drawer
      width={500}
        title="Add Details"
        placement="right"
        onClose={onClose}
        open={openAddDetailsDrawer}
      >
  <strong>
   {t("ACCOUNT_VAT_REGISTRATION_CERTIFICATE")}
   </strong><br/> <br/>



<Form form={vatForm}>
<div>
   <Form.Item name="vatUpload" className="floating-label-form-item"
                             rules={[
                               { required: true, message: t("ACCOUNT_VAT_UPLOAD_REQUEST_MSG") },
                             ]}>
                             <Fileupload
                               filetype={DocTypes.VAT_FRONT}
                               defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                 vatForm.getFieldValue("vatUpload")?.fileThumbUrl
                               )}
                               defaultFile={vatForm.getFieldValue("vatUpload")?.fileUrl}
                               fileName={vatForm.getFieldValue("vatUpload")?.fileName}
                               entityId=""
                               entityType={EntityTypes.SUPPLIER}
                               accessFile={false}
                               onChange={(value) => {
                                 onFileUploadDocs(value, "vatUpload");
                               }}
                          
                             />
                           </Form.Item>  


                             <Form.Item
                                                     name="vatNumber"
                                                     rules={[
                                                       {
                                                         required: true,
                                                         message: t("ACCOUNT_VAT_REGISTATION_MSG"),
                                                       },  {
                                                          pattern: /^[a-zA-Z0-9]+$/,
                                                          message: t("SPECIAL_CHAR_NOT_ALLOWED_KEY"), 
                                                        },
                                                            {validator:minMaxLengthValidator(min,max)}
                                                     ]}
                                                     className="floating-label-form-item"
                                                   >
                                                     <Input
                                                       placeholder={t("SIGNUP_KYC_VAT_REG_NUM_PH")}
                                                      //  value={vatForm.getFieldValue("vatNumber")}
                                                        value={kycFormValues.vatNumber}
                                                       className="floating-input-basic"
                                                       maxLength={max}
                                                       onChange={(e)=>handleFormChange("vatNumber",e.target.value)}
                                                      //  onChange={(e) =>
                                                      //    handleFormChange("vatNumber", e.target.value)
                                                      //  }
                                                     />
                                                     <span className="floating-label">
                                                       {t("ACCOUNT_KYC_DETAILS_VAT_REGISTRATION_NO")} <b className="mandate-color">*</b>
                                                     </span>
                                                   </Form.Item> 



                                                       <Form.Item
                                                        name="vatExpiry"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: t("ACCOUNT_SELECT_EXP_MSG"),
                                                          },
                                                        ]}
                                                        className="floating-label-form-item"
                                                      >
                                                        <DatePicker
                                                          className="floating-input-basic"
                                                          format={format}
                                                         value={
                                                              kycFormValues?.vatExpiry
                                                                ? dayjs(kycFormValues.vatExpiry, format)
                                                                : null
                                                                 }
                                                          style={{ fontSize: "12px" }}
                                                          disabledDate={disablePastDates}
                                                          placeholder={t("SIGNUP_KYC_VAT_REG_EXPIRY_PH")}
                                                         onChange={(date, dateString) =>
                                                           handleFormChange(
                                                             "vatExpiry",
                                                             dateString
                                                           )
                                                         }
                                                        />
                                                        <label className="floating-label">
                                                          {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")} <b className="mandate-color">*</b>
                                                        </label>
                                                      </Form.Item>
</div><br/>

{isTurkeyKazakhstanPresent ? 
<div>
  <strong>{t("FILE_VERIFY_IBAN_CERTIFICATE_NUMBER")}</strong><br/><br/>
                    {ibanNumber?.map((ele, index) => (
  <Form.Item
    key={index}
    name={`iBanNo_${index}`}
    rules={[
      { required: true, message: t("ACCOUNT_ENTER_IBAN_NO") },
      ({ getFieldValue }) => ({
        validator(_, value) {
          const ibanlength =
            user?.operatingCountry === "Kazakhstan"
              ? 20
              : user?.operatingCountry === "Turkey"
              ? 26
              : 34;
          // if (!value) {
          //   return Promise.reject(t("IBAN_REQUIRED"));
          // }
          if (value.length !== ibanlength) {
            return Promise.reject(`${t("IBAN_LENGTH_REQUIRED")} ${ibanlength}`);
          }
          return Promise.resolve();
        },
      }),
    ]}
    className="floating-label-form-item"
  >
    <Input
      value={kycFormValues?.iBanNo?.[index]}
      placeholder={t("IBAN_PLACEHOLDER")}
      className="floating-input"
      maxLength={
        props?.accountDetails?.country === "Kazakhstan"
          ? 20
          : props?.accountDetails?.country === "Turkey"
          ? 26
          : 34
      }
      onChange={(e) => {
        const updatedIbanNumbers = [...ibanNumber];
        updatedIbanNumbers[index] = e.target.value;
        setIbanNumber(updatedIbanNumbers);

        const updatedFormValues = [...(kycFormValues?.iBanNo || [])];
        updatedFormValues[index] = e.target.value;
        setKycFormValues({
          ...kycFormValues,
          iBanNo: updatedFormValues,
        });

        vatForm?.setFieldValue(`iBanNo_${index}`, e.target.value);
      }}
    />
    <label className="floating-label">
      {t("ACCOUNT_IBAN_NO")}
      <b className="mandate-color">*</b>
    </label>
  </Form.Item>
))}

                          <Row gutter={16}>
                            <Col span={16}>
                              {/* <label className='registration-lable'>{t("MUST_BE_KEY")} {accountDetails?.country === 'Kazakhstan' ? "20" : accountDetails?.country === 'Turkey' ? "26" : "34"} {t("ACCOUNT_DIGITS")}</label> */}
                            </Col>
                            <Col span={8}>
                              <Button type='secondary'
                                icon={<PlusOutlined />}
                                className="add-doc"
                                onClick={addIbanNumber}
                              >
                                {t("ACCOUNT_ADD_IBAN")}
                              </Button>
                            </Col>
                          </Row>


                               <Form.Item
                              rules={[{ required: true, message: t("ACCOUNT_SELECT_CERTIFICATION_MSG") }]}
                              name="certification"
                              className="floating-label-form-item"
                            >
                              <Select
                                options={[
                                  { label: 'K1', value: 'K1' },
                                  { label: 'C2', value: 'C2' },
                                ]}
                                value={vatForm?.getFieldValue("certification")}
                                onChange={(value) => {
                                  handleFormChange("certification", value);
                                }}
                                style={{ width: "100%", height: "56px" }}
                              />
                              <label className="floating-label">{t("ACCOUNT_CERTIFICATION")}<b className="mandate-color">*</b></label>
                            </Form.Item>
                            </div>

                            :
                            <div>
                              <strong>
                              {t("ACCOUNT_TRADE_LICENSE")}
                              </strong><br/> <br/>
                              <Form.Item name="tradeLicenseUpload" className="floating-label-form-item"
                             rules={[
                               { required: true, message: t("TRADE_DOC_UPLOAD_REQUIRED") },
                             ]}>
                             <Fileupload
                               filetype={DocTypes.TRADE_LICENSE_FRONT}
                               defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                 vatForm.getFieldValue("tradeLicenseUpload")?.fileThumbUrl
                               )}
                               defaultFile={vatForm.getFieldValue("tradeLicenseUpload")?.fileUrl}
                               fileName={vatForm.getFieldValue("tradeLicenseUpload")?.fileName}
                               entityId=""
                               entityType={EntityTypes.SUPPLIER}
                               accessFile={false}
                               onChange={(value) => {
                                 onFileUploadDocs(value, "tradeLicenseUpload");
                               }}
                          
                             />
                           </Form.Item>  


                             <Form.Item
                                                     name="tradeLicenseNumber"
                                                     rules={[
                                                       {
                                                         required: true,
                                                         message: t("TRADE_REG_NO_REQUIRED"),
                                                       }, {
                                                          pattern: /^[a-zA-Z0-9]+$/,
                                                          message: t("SPECIAL_CHAR_NOT_ALLOWED_KEY"), 
                                                        },
                                                       {validator:minMaxLengthValidator(minTrade,maxTrade)}
                                                     ]}
                                                     className="floating-label-form-item"
                                                   >
                                                     <Input
                                                       placeholder={t("ACCOUNT_TRADE_REGISTRATION_MSG")}
                                                      //  value={vatForm.getFieldValue("tradeLicenseNumber")}
                                                      value={kycFormValues?.tradeLicenseNumber}
                                                       //  value={kycDetails.vatNumber}
                                                       className="floating-input-basic"
                                                       maxLength={maxTrade}
                                                       onChange={(e) =>
                                                         handleFormChange("tradeLicenseNumber", e.target.value)
                                                       }
                                                     />
                                                     <span className="floating-label">
                                                       {t("ACCOUNT_TRADE_REGISTRATION_NO")} <b className="mandate-color">*</b>
                                                     </span>
                                                   </Form.Item> 



                                                       <Form.Item
                                                        name="tradeExpiry"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: t("ACCOUNT_SELECT_EXP_MSG"),
                                                          },
                                                        ]}
                                                        className="floating-label-form-item"
                                                      >
                                                        <DatePicker
                                                          className="floating-input-basic"
                                                          format={format}
                                                          value={
                                                                                      kycFormValues?.tradeExpiry
                                                                                        ? dayjs(kycFormValues.tradeExpiry, format)
                                                                                        : null
                                                                                    }
                                                          style={{ fontSize: "12px" }}
                                                          disabledDate={disablePastDates}
                                                          placeholder={t("SIGNUP_KYC_VAT_REG_EXPIRY_PH")}
                                                         onChange={(date, dateString) =>
                                                           handleFormChange(
                                                             "tradeExpiry",
                                                             dateString
                                                           )
                                                         }
                                                        />
                                                        <label className="floating-label">
                                                          {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")} <b className="mandate-color">*</b>
                                                        </label>
                                                      </Form.Item>
</div> 

}
<br/>
<Row>
  <Col span={12}>
  <Button onClick={onClose} style={{width:'100%'}} type='secodary'
  className="cancel-btn" >
    {t("ACCOUNT_CANCEL")}

    </Button>
  </Col>
    <Col span={12}>
    <Button  onClick={handleSumbitForm}
    loading={changeUserTypeLoader}
     type='primary'style={{width:'100%'}}
    className="submit-btn">
    {t("ACCOUNT_SAVE_CHANGES")}
      </Button>
    </Col>

</Row>
</Form>
</Drawer>

</>


  );
};

export default RequestToBroker; 